import * as React from 'react';
import { createSvgIcon } from '@fluentui/react-icons-mdl2';

const SkypeForBusinessLogoFill16Icon = createSvgIcon({
  svg: ({ classes }) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 2048 2048" className={classes.svg}>
      <path d="M1849 1127q64 77 99 160t36 185q0 106-40 199t-110 162-163 110-199 41q-102 0-185-35t-160-100q-26 4-51 5t-52 2q-115 0-221-30t-198-84-169-130-130-168-84-199-30-221q0-26 1-51t6-52q-64-77-99-160T64 576q0-106 40-199t110-162 163-110 199-41q102 0 185 35t160 100q26-4 51-5t52-2q115 0 221 30t198 84 169 130 130 168 84 199 30 221q0 26-1 51t-6 52z" />
    </svg>
  ),
  displayName: 'SkypeForBusinessLogoFill16Icon',
});

export default SkypeForBusinessLogoFill16Icon;
